._UploadModal_1f80r_1 ._button_1f80r_1 {
  width: 120px;
}
._UploadModal_1f80r_1 ._button_1f80r_1._left_1f80r_4 {
  margin-right: 20px;
}